<div style="margin: 0px;">
    <progress-loader></progress-loader>
    <router-outlet></router-outlet>
</div>
